export default "__VITE_ASSET__17322ef5__"